/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentScheduleCalendarTriggerDto } from './equipment-schedule-calendar-trigger-dto';


export interface CreateEquipmentCalendarScheduleRequestDto { 
    name?: string | null;
    triggers?: Array<EquipmentScheduleCalendarTriggerDto> | null;
}

